export interface BaseAssessment {
  id: number;
  created: string;
  lastModified: string;
  ownerFullName: string;
}

export interface DraftAssessmentDTO extends BaseAssessment {
  startedByFullName: string;
  ownerSsoId: string;
}

export class DraftAssessment implements DraftAssessmentDTO {
  id: number = 0;
  created: string = '';
  lastModified: string = '';
  startedByFullName: string = '';
  ownerFullName: string = '';
  ownerSsoId: string = '';

  constructor(dto: DraftAssessmentDTO) {
    this.update(dto);
  }

  get asJson(): DraftAssessmentDTO {
    return {
      id: this.id,
      created: this.created,
      lastModified: this.lastModified,
      startedByFullName: this.startedByFullName,
      ownerFullName: this.ownerFullName,
      ownerSsoId: this.ownerSsoId,
    };
  }

  update(newData: Partial<DraftAssessmentDTO>): DraftAssessmentDTO {
    const allData = { ...this.asJson, ...newData };

    Object.assign(this, allData);

    return this.asJson;
  }
}
